export const TOGGLE_MOBILE_OPEN_VARIABLE = "TOGGLE_MOBILE_OPEN_VARIABLE";
export const TOGGLE_IS_CLOSING_VARIABLE = "TOGGLE_IS_CLOSING_VARIABLE";
